import React from 'react';
import { BookOpenIcon, ClipboardListIcon, CompassIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
import { Section } from './Section';
const groups = [{
  icon: BookOpenIcon,
  title: 'The Complete Six-Volume Collection',
  items: ['Obesity Assessment Blueprint', 'Metabolic & Comorbidity Blueprint', 'Weight Management Planning Blueprint', 'Advanced Obesity Care Blueprint', 'Obesity Treatment Review Blueprint', 'Long-Term Obesity Care Blueprint']
}, {
  icon: ClipboardListIcon,
  title: 'Five Specialized Clinical Tools',
  items: ['Obesity Assessment Worksheet', 'Metabolic & Comorbidity Review Matrix', 'Weight Management Consultation Planner', 'Obesity Treatment Review Tracker', 'Long-Term Obesity Care Checklist']
}, {
  icon: CompassIcon,
  title: 'A Visual Clinical Navigation Framework',
  text: 'A structured overview that helps you navigate the collection according to the topic you need to review.'
}, {
  icon: FileTextIcon,
  title: 'Practical Worksheets and Checklists',
  text: 'Printable resources to organize patient information, treatment discussions, documentation, and follow-up.'
}, {
  icon: DownloadIcon,
  title: 'Instant Digital Access',
  text: 'Download the materials and keep them available within your existing professional workflow.'
}];
export function Everything() {
  return <Section tone="soft" title="Everything you need to organize your obesity care references" subtitle="With Obesity Clinical Blueprint™, you receive:" cta="Yes, I want the complete blueprint" ctaNote="One-Time Payment of $27 USD · Instant Download · 7-Day Money-Back Guarantee" data-id="element-94" data-mp="3fqem7vdauw9u">
      <div className="mx-auto max-w-3xl divide-y divide-brand/15 rounded-3xl bg-white px-6 shadow-card sm:px-8" data-id="element-95" data-mp="376qgs2ut8ge">
        {groups.map(group => {
        const Icon = group.icon;
        return <div key={group.title} className="flex gap-4 py-6" data-id="element-96" data-mp="hcywpt717etg">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand text-white" data-id="element-97" data-mp="hes4jbtds531">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-98" data-mp="8kdeqfb85c5o" />
              </span>
              <div data-id="element-99" data-mp="8iaphxhwbn20">
                <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-100" data-mp="clyymkm6eqpd">{group.title}</h3>
                {group.items && <ul className="mt-2 space-y-1" data-id="element-101" data-mp="3urbys7c1o02c">
                    {group.items.map(item => <li key={item} className="text-[16px] text-muted" data-id="element-102" data-mp="3lk9tba06th4">
                        · {item}
                      </li>)}
                  </ul>}
                {group.text && <p className="mt-1.5 text-[16px] leading-relaxed text-muted" data-id="element-103" data-mp="3ptjvyi9v2tjd">{group.text}</p>}
              </div>
            </div>;
      })}
      </div>
      <p className="mx-auto mt-8 max-w-2xl text-center text-sm italic leading-relaxed text-muted" data-id="element-104" data-mp="1o15ka0xwulbe">
        This is not intended to replace clinical training, official guidelines, or professional judgment. It is a
        practical reference collection designed to help you organize the information and review processes that support
        your work.
      </p>
    </Section>;
}